export function validateGameDefinition(_game) {
    // no-op, for now
}
/**
 * Computes game state from the initial state and rounds.
 */
export function getGameState(game, rounds, ctx) {
    const initialState = game.getInitialGlobalState(ctx);
    return rounds.reduce((state, round, i) => {
        return game.applyRoundToGlobalState({
            ...ctx,
            globalState: state,
            round,
            roundIndex: i,
        });
    }, initialState);
}
export function getGameStateFromCheckpoint(game, checkpoint, rounds, ctx) {
    return rounds.reduce((state, round, i) => {
        return game.applyRoundToGlobalState({
            ...ctx,
            globalState: state,
            round,
            roundIndex: checkpoint.roundIndex + i,
        });
    }, checkpoint.state);
}
//# sourceMappingURL=gameDefinition.js.map